// src/img/imagens.js
import CGM from './CGM.png';
import CGM1 from './CGM1.png';
import brasao from './logo.png';
import citi from './citi.png';
import clic from './clic.svg';
import PBI from './PBI.svg';
import guardar from './guardar e partilhar.png';
import sei from './sei.png';
import sigrc from './sigrc-144x144.png';
import sof from './sof.svg';
import trespontinho from './trespontinhos.png'; 
import simproc from './simproc.png';
import senhapresencial from './senhapresencial.jpeg'
import senharemoto from './senharemoto.png'
import config from './config.png'
import dadosvpn from './dadosvpn.png'
import finalvpn from './finalvpn.png'
import redeinternet from './redeinternet.png'
import usuariovpn from './usuariovpn.png'
import addvpn from './addvpn.png'
import addatalho from './addatalho.png';
import wifipmsp from './WIFI PMSPGabCGM.jpeg'


// exporta como objeto
const Imagens = {
  CGM,
  CGM1,
  brasao,
  citi,
  clic,
  PBI,
  guardar,
  sei,
  sigrc,
  sof,
  trespontinho, 
  simproc, 
  senhapresencial, 
  senharemoto,
  config, 
  dadosvpn, 
  finalvpn, 
  redeinternet, 
  usuariovpn, 
  addvpn,
  addatalho,
  wifipmsp
};

export default Imagens;
